import type { IconNode } from '../types';

/**
 * @name bottle-dispenser
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxOC41IiBjeT0iNS41IiByPSIuNSIgLz4KICA8cGF0aCBkPSJNMjAgMTBoLjAxIiAvPgogIDxwYXRoIGQ9Ik05IDJoNyIgLz4KICA8cGF0aCBkPSJNMTEgMnY0IiAvPgogIDxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHg9IjkiIHk9IjYiIHJ4PSIxIiAvPgogIDxwYXRoIGQ9Ik05IDEwYy0xLjcgMC0zIDEuMy0zIDN2N2EyIDIgMCAwIDAgMiAyaDZhMiAyIDAgMCAwIDItMnYtN2MwLTEuNy0xLjMtMy0zLTNaIiAvPgogIDxwYXRoIGQ9Ik02IDE0LjVhNiA2IDAgMCAxIDUgMHMyIDEuMjUgNSAwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bottle-dispenser
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bottleDispenser: IconNode = [
  ['circle', { cx: '18.5', cy: '5.5', r: '.5', key: '56iowl' }],
  ['path', { d: 'M20 10h.01', key: '1s95w0' }],
  ['path', { d: 'M9 2h7', key: '31zqg3' }],
  ['path', { d: 'M11 2v4', key: 'ylyxaf' }],
  ['rect', { width: '4', height: '4', x: '9', y: '6', rx: '1', key: '1g7bef' }],
  [
    'path',
    {
      d: 'M9 10c-1.7 0-3 1.3-3 3v7a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-7c0-1.7-1.3-3-3-3Z',
      key: 'iame6j',
    },
  ],
  ['path', { d: 'M6 14.5a6 6 0 0 1 5 0s2 1.25 5 0', key: 'bbz0ie' }],
];

export default bottleDispenser;
